import { render, staticRenderFns } from "./AdjustTable.vue?vue&type=template&id=8284d614&"
import script from "./AdjustTable.vue?vue&type=script&lang=js&"
export * from "./AdjustTable.vue?vue&type=script&lang=js&"
import style0 from "./AdjustTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports